module.exports = __webpack_public_path__ + "img/sousuo.8ce1d931.svg";